import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Grid from "../../atoms/layout-primitives/grid.ts"
import Spacer from "../../atoms/layout-primitives/spacer"
import { T } from "../../atoms/text"
import ClientsGrid from "../../organisms/clients-grid"
import VariantContainer from "../../atoms/variant-container"

export default function Clients() {
  const query = useStaticQuery(graphql`
    query {
      desktopLogos: file(
        relativePath: { eq: "0_HOMEPAGE/clients/client logos - desktop.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      tabletLogos: file(
        relativePath: { eq: "0_HOMEPAGE/clients/client logos - tablet.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1024) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mobileLogos: allFile(
        filter: { relativeDirectory: { eq: "0_HOMEPAGE/clients/mobile" } }
        sort: { fields: base }
      ) {
        edges {
          node {
            id
            base
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  return (
    <>
      <VariantContainer
        variants={[
          css`
            background-color: var(--light-background);
          `
        ]}
      >
        <Grid>
          <Spacer height={{ sm: "32px", md: "48px", lg: "64px" }}/>
          <ClientsGrid
            title="Trusted By Teams At: "
            titleLine={true}
            containerVariants={[
              css`
                box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
              `
            ]}
            blockVariants={[
              css`
                box-shadow: none;
              `
            ]}
            titleVariants={[
              css`
                ${T.sm.h4`400`}
                margin-top: 24px
              `,
              css`
                ${T.md.h3`400`}
                margin-top: 48px
              `,
              css`
                ${T.lg.h3`400`}
                margin-top: 64px
              `
            ]}
            mobileLogos={query.mobileLogos.edges}
            tabletLogos={query.tabletLogos.childImageSharp.fluid}
            desktopLogos={query.desktopLogos.childImageSharp.fluid}
          />
          <Spacer height={{ sm: "32px", md: "48px", lg: "64px" }}/>
        </Grid>
      </VariantContainer>
    </>
  )
}
